import { useLayoutEffect } from 'react';
import { useModalManager } from './useModalManager';

export function useModalManagerPageLocking() {
  const { hasActiveModal } = useModalManager();

  useLayoutEffect(() => {
    function updatePageLock() {
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('--gap');

      if (hasActiveModal) {
        const windowWidth = window.innerWidth;
        const documentWidth = document.documentElement.clientWidth;

        const scrollGap = windowWidth - documentWidth;
        // Add 0.25 to counter browser half pixel that's not reported in documentWidth and windowWidth
        const adjustedScrollGap = scrollGap + (scrollGap > 0 ? 0.25 : 0);

        document.documentElement.style.setProperty('overflow', 'hidden');
        document.body.style.setProperty('overflow', 'hidden');
        document.body.style.setProperty('width', `${windowWidth - adjustedScrollGap}px`);
        document.body.style.setProperty('--gap', `${adjustedScrollGap}px`);
      }
    }

    if (hasActiveModal) window.addEventListener('resize', updatePageLock);
    updatePageLock();

    return () => {
      window.removeEventListener('resize', updatePageLock);
    };
  }, [hasActiveModal]);
}
